import { Component, computed, inject, input } from '@angular/core';
import { TableComponent } from '../../../../modules/shared/components/kit/table/table.component';
import { TableColumn } from '../../../../modules/shared/components/kit/table/table.types';
import {
    dateTimeField,
    longTextField,
    textColumn,
    userChipField,
} from '../../../../modules/shared/components/kit/table/table.fields';
import { UserChipRenderTypeEnum } from '../../../kit/user-chip/user-chip.component.types';
import { MessageRecipientsTableStore } from './message-recipients-table.store';
import { messageRecipientsTableFrag } from './message-recipients-table.query';

@Component({
    selector: 'app-message-recipients-table',
    templateUrl: './message-recipients-table.component.html',
    providers: [MessageRecipientsTableStore],
    imports: [
        TableComponent,
    ],
})
export class MessageRecipientsTableComponent {

    protected readonly store = inject(MessageRecipientsTableStore);

    public messageId = input<number | null>(null);

    protected readonly prefix = 'messages.recipients.';
    protected readonly fragment = messageRecipientsTableFrag;

    protected readonly columns: TableColumn[] = [
        longTextField('organizationNames', false, false),
        userChipField('user', UserChipRenderTypeEnum.User),
        dateTimeField('readAt'),
    ];

    protected readonly additionalFilter = computed(() => {
        const id = this.messageId();
        if (!id) return null;
        return [[{
            column: 'messageId',
            operator: 'EQ',
            value: [String(id)],
        }]];
    });

    protected readonly transformItem = (item: any) => ({
        ...item,
        organizationNames: (item?.user?.organizations ?? [])
            .map((uo: any) => uo?.organization?.name ?? uo?.id)
            .filter(Boolean)
            .join(', '),
    });

}
